import request from './request'

export function queryVideoList(data) {
  data = Object.assign({}, data, { openid: sessionStorage.getItem("openId") })
  return request({
    method: 'post',
    url: '/ufc/api/article/queryVideoList',
    data
  })
}

export function selectAisAgentCard(data) {
  data = Object.assign({}, data, { id: sessionStorage.getItem("openId") })
  return request({
    url: 'prizecustomer/api/agent-card/selectAisAgentCard',
    params: data
  })
}

export function ws(params) {
  return request({
    url: '/ufc/weixin/ws',
    params
  })
}
